import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IntegrationsMarketplaceGridInstalledDataProviderFactory } from '../factory/IntegrationsMarketplaceGridInstalledDataProviderFactory';
import {
  CustomTemplateListRequest,
  CustomTemplateListResponse, UpdateIntegrationResponse,
  GetItemsResponse
} from "../../../ui/gzCustomTemplateList/types";
import {
  IntegrationsMarketplaceGridInstalledNirvanaDataProvider
} from "../dataProvider/IntegrationsMarketplaceGridInstalledNirvanaDataProvider";

export class IntegrationsMarketplaceGridInstalledRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrationsMarketplaceGridInstalledDataProviderFactory;
  public dataProvider: IntegrationsMarketplaceGridInstalledNirvanaDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrationsMarketplaceGridInstalledDataProviderFactory(),
    });
  }

  async getItems(request: CustomTemplateListRequest): Promise<GetItemsResponse> {
    return this.dataProvider.getItems(request);
  }

  async deleteIntegration(payload: any): Promise<UpdateIntegrationResponse> {
    return this.dataProvider.deleteIntegration(payload);
  }

  async disableIntegration(payload: any): Promise<UpdateIntegrationResponse> {
    return this.dataProvider.disableIntegration(payload);
  }
  async enableIntegration(payload: any): Promise<UpdateIntegrationResponse> {
    return this.dataProvider.enableIntegration(payload);
  }
}
